import React from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import {
  UpdateCarAgentListing,
  AddMedia,
  UpdateCarDealerListing,
  getCarDealerListing,
} from './../../../../Redux/Actions/UserAction';
import Sidebar from '../../../common/Sidebar/Sidebar';
import { timeOptions } from '../../../../Options';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';

const openStatus = ['OPEN', 'مفتوح'];

const CarDealersWorkingHours = () => {
  const { t } = useTranslation();
  const home = useSelector((state) => state?.home);
  const CarDealertList = home?.CarDealertList;
  const getMybusiness = home?.getMybusiness;

  // After a save the action reloads, which wipes the store. The business id
  // arrives either from Redux (getMybusiness) or from sessionStorage (set by
  // the Header once /business/my resolves) — fetch the owner's listing as soon
  // as it's known so the form repopulates.
  const ownerBid =
    (getMybusiness?.businessId && String(getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');
  const validBid =
    ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null' && ownerBid !== '';

  const [CarDealersData, setCarDealersData] = useState({
    calendar: {
      SUNDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      MONDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      TUESDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      WEDNESDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      THURSDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      FRIDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      SATURDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
    },
  });

  const handleChange = (e) => {
    console.log('e is the value', e);
    if (e.target.id === 'SUNDAY') {
      setCarDealersData({
        ...CarDealersData,
        calendar: {
          ...CarDealersData.calendar,
          SUNDAY: {
            ...CarDealersData.calendar.SUNDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'MONDAY') {
      setCarDealersData({
        ...CarDealersData,
        calendar: {
          ...CarDealersData.calendar,
          MONDAY: {
            ...CarDealersData.calendar.MONDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'TUESDAY') {
      setCarDealersData({
        ...CarDealersData,
        calendar: {
          ...CarDealersData.calendar,
          TUESDAY: {
            ...CarDealersData.calendar.TUESDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'WEDNESDAY') {
      setCarDealersData({
        ...CarDealersData,
        calendar: {
          ...CarDealersData.calendar,
          WEDNESDAY: {
            ...CarDealersData.calendar.WEDNESDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'THURSDAY') {
      setCarDealersData({
        ...CarDealersData,
        calendar: {
          ...CarDealersData.calendar,
          THURSDAY: {
            ...CarDealersData.calendar.THURSDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'FRIDAY') {
      setCarDealersData({
        ...CarDealersData,
        calendar: {
          ...CarDealersData.calendar,
          FRIDAY: {
            ...CarDealersData.calendar.FRIDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'SATURDAY') {
      setCarDealersData({
        ...CarDealersData,
        calendar: {
          ...CarDealersData.calendar,
          SATURDAY: {
            ...CarDealersData.calendar.SATURDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    }
  };

  useEffect(() => {
    if (CarDealertList?.length > 0) {
      let calendar;
      try {
        calendar =
          typeof CarDealertList?.[0]?.calendar === 'string'
            ? JSON.parse(CarDealertList?.[0]?.calendar)
            : CarDealertList?.[0]?.calendar;
      } catch (e) {
        calendar = undefined;
      }
      setCarDealersData({
        calendar: {
          SUNDAY: {
            status: calendar?.SUNDAY?.status,
            openTime: calendar?.SUNDAY?.openTime,
            endTime: calendar?.SUNDAY?.endTime,
          },
          MONDAY: {
            status: calendar?.MONDAY?.status,
            openTime: calendar?.MONDAY?.openTime,
            endTime: calendar?.MONDAY?.endTime,
          },
          TUESDAY: {
            status: calendar?.TUESDAY?.status,
            openTime: calendar?.TUESDAY?.openTime,
            endTime: calendar?.TUESDAY?.endTime,
          },
          WEDNESDAY: {
            status: calendar?.WEDNESDAY?.status,
            openTime: calendar?.WEDNESDAY?.openTime,
            endTime: calendar?.WEDNESDAY?.endTime,
          },
          THURSDAY: {
            status: calendar?.THURSDAY?.status,
            openTime: calendar?.THURSDAY?.openTime,
            endTime: calendar?.THURSDAY?.endTime,
          },
          FRIDAY: {
            status: calendar?.FRIDAY?.status,
            openTime: calendar?.FRIDAY?.openTime,
            endTime: calendar?.FRIDAY?.endTime,
          },
          SATURDAY: {
            status: calendar?.SATURDAY?.status,
            openTime: calendar?.SATURDAY?.openTime,
            endTime: calendar?.SATURDAY?.endTime,
          },
        },
      });
    }
  }, [CarDealertList]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (validBid) {
      dispatch(getCarDealerListing(ownerBid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerBid]);
  const datasubmit = (e) => {
    e.preventDefault();
    console.log('tihs is image section', CarDealersData);
    dispatch(UpdateCarDealerListing(CarDealersData));
  };

  const ResetHendler = () => {
    setCarDealersData({
      calendar: {
        SUNDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        MONDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        TUESDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        WEDNESDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        THURSDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        FRIDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        SATURDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
      },
    });
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-car-dealers-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-car-dealers-cars',
      label: t('Manage Cars'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-car-dealers-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-car-dealers-working-hours',
      label: t('Manage Working Hours'),
    },
  ];
  console.log('CarDealertList', CarDealertList, CarDealersData);

  const isPaymentPlanActive = sessionStorage.getItem('paymentPlan');

  return (
    <div>
      <CommonBusinessHeader
        dataList={CarDealertList}
        getNameKey="carDealerName"
      />

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2 class="mb-4">{t('Manage Working Hours')}</h2>
              <form onSubmit={datasubmit}>
                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Day')}</div>
                    </div>
                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="mwh-day">{t('From')}</label>
                    </div>
                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="mwh-day">{t('To')}</label>
                    </div>
                  </div>
                </div>
                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Sunday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="SUNDAY"
                        value={CarDealersData.calendar.SUNDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.SUNDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="endTime"
                        id="SUNDAY"
                        value={CarDealersData.calendar.SUNDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.SUNDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarDealersData.calendar.SUNDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SUNDAY"
                            onChange={(checked) => {
                              setCarDealersData({
                                ...CarDealersData,
                                calendar: {
                                  ...CarDealersData.calendar,
                                  SUNDAY: {
                                    ...CarDealersData.calendar.SUNDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={CarDealersData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox1'
														value='option1'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Monday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="MONDAY"
                        value={CarDealersData.calendar.MONDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.MONDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="endTime"
                        id="MONDAY"
                        value={CarDealersData.calendar.MONDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.MONDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarDealersData.calendar.MONDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SUNDAY"
                            onChange={(checked) => {
                              setCarDealersData({
                                ...CarDealersData,
                                calendar: {
                                  ...CarDealersData.calendar,
                                  MONDAY: {
                                    ...CarDealersData.calendar.MONDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={CarDealersData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox2'
														value='option2'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Tuesday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="TUESDAY"
                        value={CarDealersData.calendar.TUESDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.TUESDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="endTime"
                        id="TUESDAY"
                        value={CarDealersData.calendar.TUESDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.TUESDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarDealersData.calendar.TUESDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="TUESDAY"
                            onChange={(checked) => {
                              setCarDealersData({
                                ...CarDealersData,
                                calendar: {
                                  ...CarDealersData.calendar,
                                  TUESDAY: {
                                    ...CarDealersData.calendar.TUESDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={CarDealersData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox3'
														value='option3'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Wednesday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="WEDNESDAY"
                        value={CarDealersData.calendar.WEDNESDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.WEDNESDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="endTime"
                        id="WEDNESDAY"
                        value={CarDealersData.calendar.WEDNESDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.WEDNESDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarDealersData.calendar.WEDNESDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="WEDNESDAY"
                            onChange={(checked) => {
                              setCarDealersData({
                                ...CarDealersData,
                                calendar: {
                                  ...CarDealersData.calendar,
                                  WEDNESDAY: {
                                    ...CarDealersData.calendar.WEDNESDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={CarDealersData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox4'
														value='option4'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Thursday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="THURSDAY"
                        value={CarDealersData.calendar.THURSDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.THURSDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="endTime"
                        id="THURSDAY"
                        value={CarDealersData.calendar.THURSDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.THURSDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarDealersData.calendar.THURSDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="THURSDAY"
                            onChange={(checked) => {
                              setCarDealersData({
                                ...CarDealersData,
                                calendar: {
                                  ...CarDealersData.calendar,
                                  THURSDAY: {
                                    ...CarDealersData.calendar.THURSDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={CarDealersData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox5'
														value='option5'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Friday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="FRIDAY"
                        value={CarDealersData.calendar.FRIDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.FRIDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="endTime"
                        id="FRIDAY"
                        value={CarDealersData.calendar.FRIDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.FRIDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarDealersData.calendar.FRIDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="FRIDAY"
                            onChange={(checked) => {
                              setCarDealersData({
                                ...CarDealersData,
                                calendar: {
                                  ...CarDealersData.calendar,
                                  FRIDAY: {
                                    ...CarDealersData.calendar.FRIDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={CarDealersData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox6'
														value='option6'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Saturday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="SATURDAY"
                        value={CarDealersData.calendar.SATURDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.SATURDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="endTime"
                        id="SATURDAY"
                        value={CarDealersData.calendar.SATURDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarDealersData.calendar.SATURDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarDealersData.calendar.SATURDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SATURDAY"
                            onChange={(checked) => {
                              setCarDealersData({
                                ...CarDealersData,
                                calendar: {
                                  ...CarDealersData.calendar,
                                  SATURDAY: {
                                    ...CarDealersData.calendar.SATURDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox7'
														value='option7'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-5 ">
                  <div class="col-6">
                    <button
                      type="reset"
                      // onClick={ResetHendler}
                      class="btn btn-secondary btn-block"
                      href="#"
                      onClick={ResetHendler}
                      // role='button'
                    >
                      {t('Reset')}
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      type="submit"
                      // to='/sp-garages-packages'
                      className="btn btn-warning btn-block"
                      // href='sp-garages-manage-business-packages.html'
                      // role='button'
                    >
                      {t('Submit')}
                    </button>
                    {/* {isPaymentPlanActive == 'true' ? (
                    ) : (
                      <a
                        class="btn btn-warning btn-block"
                        href="#/manage-package"
                        role="button"
                      >
                        Buy Subscription
                      </a>
                    )} */}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarDealersWorkingHours;
